import { render, staticRenderFns } from "./graph-block.vue?vue&type=template&id=ff8d6404&scoped=true"
import script from "./graph-block.vue?vue&type=script&lang=js"
export * from "./graph-block.vue?vue&type=script&lang=js"
import style0 from "./graph-block.vue?vue&type=style&index=0&id=ff8d6404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8d6404",
  null
  
)

export default component.exports